<script lang="ts">
  import { onMount } from 'svelte';
  import { slide } from 'svelte/transition';

  export let title: string | null = null;
  export let description: string | null = null;
  export let marginBottom: string = '0';
  export let marginTop: string = '0';
  let animationDuration = 300;

  let element: HTMLDivElement;
  onMount(() => {
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  });
</script>

<div class="main-alert" transition:slide={{ duration: animationDuration }} style="margin-bottom: {marginBottom}; margin-top: {marginTop}" bind:this={element}>
  <div class="main-alert-icon">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
      />
    </svg>
  </div>
  <div class="main-alert-content">
    {#if title}
      <div class="main-alert-title">{title}</div>
    {/if}
    {#if description}
      <div class="main-alert-description">{description}</div>
    {/if}
  </div>
</div>

<style>
  .main-alert {
    pointer-events: all;
    max-width: 650px;
    border-radius: 8px;
    background-color: var(--error);
    padding: 10px 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    scroll-margin-top: 100px;
  }

  .main-alert-icon {
    display: flex;
    width: 36px;
    min-width: 36px;
    height: 36px;
    margin-right: 14px;
    background-color: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
  }

  .main-alert-icon svg {
    width: 30px;
    height: 30px;
  }
  .main-alert-content {
    display: flex;
    flex-direction: column;
  }

  .main-alert-title {
    font-size: 14px;
    font-weight: 600;
    color: #fff;
  }

  .main-alert-description {
    font-size: 14px;
    color: #fff;
  }
</style>
